import { orderCatalogue } from "./catalogue-order";
export const CAROUSEL_TYPES = [
    "curated",
    "query",
    "epg",
    "recommended",
    "continue_watching",
];
export const LIVE_CAROUSEL_TYPES = [
    "curated",
    "query",
    "epg",
];
export const NON_TRANSFORMED_CAROUSEL_TYPES = [
    "recommended",
    "continue_watching",
];
export function isLiveCarouselType(type) {
    return LIVE_CAROUSEL_TYPES.includes(type);
}
export function carouselSlug(name) {
    return (name
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/ß/g, "ss")
        .replace(/æ/g, "ae")
        .replace(/ø/g, "o")
        .replace(/đ/g, "d")
        .replace(/ł/g, "l")
        .replace(/[^\w\s-]/g, "")
        .trim()
        .replace(/[\s-]+/g, "_")
        .toLowerCase());
}
export const CAROUSEL_DISPLAY_LIMITS = {
    CAROUSEL: 10,
    SEE_ALL: 40,
};
export function carouselPageSize(view, displayLimit) {
    if (view === "SEE_ALL")
        return CAROUSEL_DISPLAY_LIMITS.SEE_ALL;
    return displayLimit || CAROUSEL_DISPLAY_LIMITS.CAROUSEL;
}
export function showsNonPurchasedContent(params) {
    const { premiseShowsNonPurchased, carouselShowsNonPurchased } = params;
    const carousel = carouselShowsNonPurchased !== null && carouselShowsNonPurchased !== void 0 ? carouselShowsNonPurchased : true;
    const premise = premiseShowsNonPurchased !== null && premiseShowsNonPurchased !== void 0 ? premiseShowsNonPurchased : false;
    return carousel ? premise : false;
}
export const AVAILABILITY_RANK = {
    AVAILABLE: 0,
    PARTIAL: 0,
    UNKNOWN: 1,
    UNAVAILABLE: 2,
};
export function sortCarouselsByAvailability(carousels) {
    return [...carousels].sort((a, b) => {
        var _a, _b;
        return AVAILABILITY_RANK[(_a = a.availabilityStatus) !== null && _a !== void 0 ? _a : "UNKNOWN"] -
            AVAILABILITY_RANK[(_b = b.availabilityStatus) !== null && _b !== void 0 ? _b : "UNKNOWN"];
    });
}
export function carouselAvailabilityFromAssets(params) {
    var _a;
    const { assetCount, entitledCount, hasProducts } = params;
    if (assetCount === 0) {
        return ((_a = params.pageNumber) !== null && _a !== void 0 ? _a : 1) > 1 ? "AVAILABLE" : "UNAVAILABLE";
    }
    if (!hasProducts)
        return "UNKNOWN";
    if (entitledCount === assetCount)
        return "AVAILABLE";
    if (entitledCount > 0)
        return "PARTIAL";
    return "UNAVAILABLE";
}
export function carouselRailVisible(params) {
    var _a;
    const { type, showsNonPurchased } = params;
    const status = (_a = params.availabilityStatus) !== null && _a !== void 0 ? _a : "UNKNOWN";
    if (showsNonPurchased)
        return true;
    if (type === "epg")
        return status === "AVAILABLE";
    return status !== "UNAVAILABLE";
}
export function subPageVisible(params) {
    const { carousels } = params;
    if (carousels.length === 0)
        return false;
    if (params.premiseShowsNonPurchased)
        return true;
    return carousels.some((c) => { var _a; return ((_a = c.availabilityStatus) !== null && _a !== void 0 ? _a : "UNKNOWN") !== "UNAVAILABLE"; });
}
export function subPageIconForApp(icon) {
    if (!icon)
        return null;
    return icon.replace("_", "-");
}
export function carouselLanguages(carousel) {
    var _a, _b;
    const seen = new Set();
    for (const t of (_a = carousel.title) !== null && _a !== void 0 ? _a : []) {
        const lang = (_b = t === null || t === void 0 ? void 0 : t.language) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase();
        if (lang)
            seen.add(lang);
    }
    return [...seen];
}
export function carouselIssues(carousel) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const issues = [];
    const type = carousel.type;
    if (!((_a = carousel.name) === null || _a === void 0 ? void 0 : _a.trim()))
        issues.push({ code: "name_missing" });
    const titles = (_b = carousel.title) !== null && _b !== void 0 ? _b : [];
    if (titles.length === 0)
        issues.push({ code: "title_missing" });
    const seenLanguages = new Set();
    for (const t of titles) {
        const lang = (_c = t === null || t === void 0 ? void 0 : t.language) === null || _c === void 0 ? void 0 : _c.trim().toLowerCase();
        if (!((_d = t === null || t === void 0 ? void 0 : t.text) === null || _d === void 0 ? void 0 : _d.trim())) {
            issues.push({ code: "title_blank_text", subject: lang || undefined });
        }
        if (lang) {
            if (seenLanguages.has(lang)) {
                issues.push({ code: "title_duplicate_language", subject: lang });
            }
            seenLanguages.add(lang);
        }
    }
    if (!isLiveCarouselType(type)) {
        issues.push({ code: "type_not_rendered", subject: type });
    }
    if (type === "curated" && ((_e = carousel.assetIds) !== null && _e !== void 0 ? _e : []).length === 0) {
        issues.push({ code: "curated_no_assets" });
    }
    if (type === "query") {
        const hasFilter = ((_f = carousel.tagIds) !== null && _f !== void 0 ? _f : []).length > 0 ||
            ((_g = carousel.assetTypeFilter) !== null && _g !== void 0 ? _g : []).length > 0 ||
            Boolean(carousel.sourceType) ||
            Boolean(carousel.featureSetId);
        if (!hasFilter)
            issues.push({ code: "query_no_filters" });
    }
    if (type === "epg") {
        if (!((_h = carousel.channelId) === null || _h === void 0 ? void 0 : _h.trim()))
            issues.push({ code: "epg_no_channel" });
        if (((_j = carousel.assetIds) !== null && _j !== void 0 ? _j : []).length > 0) {
            issues.push({ code: "epg_assets_ignored" });
        }
    }
    if (carousel.displayLimit !== undefined && carousel.displayLimit <= 0) {
        issues.push({ code: "display_limit_not_positive" });
    }
    return issues;
}
export function emptyCarousel() {
    return {
        id: "",
        name: "",
        title: [],
        type: "curated",
        assetIds: [],
        tagIds: [],
        assetTypeFilter: [],
        liveEventChannelFilter: [],
        showNonPurchasedContent: true,
        logicConnector: "AND",
        displayLimit: CAROUSEL_DISPLAY_LIMITS.CAROUSEL,
    };
}
export function emptySubPage() {
    return { id: "", name: "", carousels: [], title: [], draft: true };
}
export function carouselWriteBody(draft) {
    return {
        name: draft.name,
        title: draft.title,
        type: draft.type,
        assetIds: draft.assetIds,
        tagIds: draft.tagIds,
        channelId: draft.channelId,
        assetTypeFilter: draft.assetTypeFilter,
        sourceType: draft.sourceType,
        featureSetId: draft.featureSetId,
        assetOrder: draft.assetOrder,
        liveEventChannelFilter: draft.liveEventChannelFilter,
        sort: draft.sort,
        groupByTitle: draft.groupByTitle,
        filterDuplicates: draft.filterDuplicates,
        showNonPurchasedContent: draft.showNonPurchasedContent,
        logicConnector: draft.logicConnector,
        displayLimit: draft.displayLimit,
        page: draft.page,
    };
}
export function railSetForRoom(params) {
    var _a, _b, _c;
    const explicit = (_a = params.premiseCarousels) !== null && _a !== void 0 ? _a : [];
    const off = new Set((_b = params.disabled) !== null && _b !== void 0 ? _b : []);
    const members = [];
    const seen = new Set();
    for (const id of [...explicit, ...((_c = params.derived) !== null && _c !== void 0 ? _c : [])]) {
        if (typeof id !== "string" || !id || seen.has(id) || off.has(id))
            continue;
        seen.add(id);
        members.push(id);
    }
    return orderCatalogue(members.map((id) => ({ id })), explicit).map((m) => m.id);
}
